import React from 'react';
import { FadeIn } from './FadeIn';
import { Check } from 'lucide-react';
export function ProductIntro() {
  const features = ['What to request', 'What to look for', 'What to say', 'When to escalate', 'How to reduce balances legally'];
  return <section className="bg-brown-900 text-cream-50 py-12 md:py-20" data-id="element-177">
      <div className="max-w-3xl mx-auto px-6" data-id="element-178">
        <FadeIn data-id="element-179">
          <div className="text-center mb-12" data-id="element-180">
            <span className="text-terracotta-500 font-medium tracking-widest uppercase text-sm mb-4 block" data-id="element-181">
              Introducing
            </span>
            <h2 className="text-4xl md:text-6xl mb-4 text-cream-50" data-id="element-182">
              Stop Overpaying Medical Bills
            </h2>
            <p className="text-xl md:text-2xl text-cream-200 font-light max-w-2xl mx-auto leading-relaxed" data-id="element-183">
              The Step-By-Step Healthcare Negotiation Blueprint for Women Who
              Refuse to Be Overcharged
            </p>
          </div>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-184">
          <div className="bg-brown-800/50 p-8 rounded-2xl border border-brown-600 mb-12 backdrop-blur-sm" data-id="element-185">
            <p className="text-lg mb-8 text-center text-cream-100" data-id="element-186">
              This is not a legal textbook. Not a protest guide. Not complicated
              finance theory. It's a clear, structured system that shows you
              exactly:
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-y-4 gap-x-8 max-w-xl mx-auto" data-id="element-187">
              {features.map((feature, i) => <div key={i} className="flex items-center" data-id="element-188">
                  <div className="bg-terracotta-500 rounded-full p-1 mr-3 flex-shrink-0" data-id="element-189">
                    <Check className="w-3 h-3 text-white" strokeWidth={3} data-id="element-190" />
                  </div>
                  <span className="text-lg font-medium" data-id="element-191">{feature}</span>
                </div>)}
            </div>
          </div>

          <div className="text-center" data-id="element-192">
            <p className="text-2xl font-semibold text-terracotta-400" data-id="element-193">
              No arguing. No drama. Just structure.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}